module.exports = __webpack_public_path__ + "static/media/298419.e5c283ab.png";